import React from "react";
import FAQ from "../components/FAQ";
import styled from "styled-components";

const FAQPageWrapper = styled.div`
  padding-top: 120px;
  min-height: 100vh;
  background: #fff;
`;

const Container = styled.div`
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;
`;

const PageHeader = styled.div`
  text-align: center;
  margin-bottom: 80px;
`;

const PageTitle = styled.h1`
  font-size: 3rem;
  color: var(--text-dark);
  margin-bottom: 20px;
  font-family: "Phudu", sans-serif;

  @media (max-width: 768px) {
    font-size: 2.5rem;
  }
`;

const PageSubtitle = styled.p`
  font-size: 1.2rem;
  color: var(--text-light);
  max-width: 600px;
  margin: 0 auto;
  line-height: 1.6;
`;

const FAQPage = () => {
  return (
    <FAQPageWrapper>
      <Container>
        <PageHeader>
          <PageTitle>Frequently Asked Questions</PageTitle>
          <PageSubtitle>
            Find answers to common questions about our container services,
            delivery options, and more. Can't find what you're looking for?
            Contact us directly.
          </PageSubtitle>
        </PageHeader>
        <FAQ />
      </Container>
    </FAQPageWrapper>
  );
};

export default FAQPage;
